/* Add preference  Mar 13, 2022  */
/* Amend Debrief Questions July 17, 2023 */
/* Amend Custom Fields Sep 23, 2023 */
/* Add Custom Fields for Accounts, Competitors, Contacts and Team Members Nov 18, 2023 */
/* Add Construction Scope, Vendor Status Dec 30, 2023 */
/* Add kt-myPages-settings Apr 20, 2024 */
/* Add Multiple Selection Dec 14, 2024 */
/* Enable record ordering:Record Dragging, add Save button Feb 22 2025 */
/* Add grouping of CustomField   Feb 22, 2025 */
/* Add Interfaces  July 31, 2026 */
<template lang="pug">
	div(class="kt-settings-tbl small")
		//- Header
		div
			b-button(class="btn-add" title="Add New" size="sm" variant="primary" @click="m_addSetting()")
				fa-icon(icon="plus" class="mr-1")
				|Add
		div(v-if="p_settingProps.context == 'customField'"  class="form-group" style="width:20%;")
			label(class="required-label") Used on
			b-form-select(size="sm" :options="d_usedOn" plain v-model="d_context" required)
		//- Table
		b-table-simple(small hover id="draggableTable" :table-class="c_grpKey!='usr'?'draggable-table':''")
			b-thead
				b-th(class="th-edit")
				b-th(v-for="(col,ixc) in d_cols.filter(x=> x.title !='Id'&&x.title !='Used on')" :key="ixc" :class="col.thClass || null") {{col.title || d_util.fn_humanizeLabel(col.key)}}
			b-tbody
				b-tr(v-for="(row,ixr) in c_data" :key="ixr" :class="m_rowClassNm(ixr)")
					b-td()
						span(v-if="ixr == d_savedIx" class="ml-1")
							fa-icon(icon="check" class="text-success")
						b-icon(v-if="c_grpKey != 'usr'" icon="arrow-down-up" class="btn-reorder")
						b-dropdown(variant="grey1" lazy=true)
							b-dd-item(@click="m_editSetting(row, ixr)")
								fa-icon(icon="pencil-alt")
								|  Edit
							b-dd-item(@click="m_deleteSetting(row, ixr)")
								fa-icon(icon="times")
								|  Delete
							template(v-slot:button-content )
								fa-icon(icon="bars" class="text-primary")
					b-td(v-for="(col,ixc) in d_cols.filter(x=> x.title !='Id'&&x.title !='Used on')" :key="ixc" :class="col.tdClass")
						input(v-if="col.key == 'disabled'" type="checkbox"  :checked="row.disabled")
						div(v-else-if="/(created|updated)/.test(col.key)")
							p {{d_util.fn_fmtDtm(row[col.key+'UTC'])}}
							p {{row[col.key+'By']}}
						p(v-else-if="col.key=='permissions'" v-for="(p,pix) in row.permissions||[]" :key="pix") {{d_util.fn_humanizeLabel(p)}}
						span(v-else) {{m_tdFmt(row, col)}}
		//- Modal
		b-modal(
			id="bm-kt-settings-tbl-item" size="md" button-size="sm" header-class="py-2" header-bg-variant="light"
			body-class="py-2" footer-class="pt-0 flex-row-reverse modalFooter" cancel-variant="outline-secondary"
			centered no-fade no-close-on-backdrop hide-header-close ok-title="Save"
			@ok="m_saveSetting"  @cancel="d_editIx = null")
			//- User Settings - Permissions
			div(v-if="c_grpKey == 'usr'" class="mb-3")
				div(class="form-group" v-if="d_rowModal.id")
					label Id
					span {{d_rowModal.appUserId}}
				div(class="form-group")
					label Team Member
					b-form-select(size="sm" v-model="d_rowModal.appUserId" :options="c_userOpt" :disabled="d_rowModal.id==-1")
				div(class="form-group")
					label Permissions
					b-form-checkbox-group(size="sm" v-model="d_rowModal.permissions" :options="c_permsOpt" stacked )
					//- div
						b-form-checkbox(size="sm" v-for="(x, ix) in c_permsOpt" :key="ix") 
							template(slot="default")
								span {{x.text}}
								kt-tt-info(:p_infoTxt="'TEST'")
							
				<kt-myPages-settings p_title="Page Settings" :p_appUserId="c_appUserId" :p_settingData="p_settingData" :p_save="c_saved" />
			//- Dropdown Options
			div(v-else-if="c_grpKey == 'ddo'" class="mb-3")
				div(class="form-group" v-if="d_rowModal.id")
					label Id
					span {{d_rowModal.id}}
				div(class="form-group")
					label(class="required-label") Name
					b-form-input(size="sm" v-model="d_rowModal.name")
				div(class="form-group")
					label Description
					b-form-textarea(size="sm" v-model="d_rowModal.desc" no-resize rows=3) 
				div(class="form-group")
					label Disabled
					b-form-checkbox(:value="true" v-model="d_rowModal.disabled") (Removes value from dropdown selection)
					
			//- Custom Fields and codes
			div(v-else-if="p_settingProps.context == 'customField'" class="mb-3")
				div(class="form-group" v-if="d_rowModal.id")
					label Id
					span {{d_rowModal.id}}
				div(class="form-group")
					label(class="required-label") Label
					b-form-input(size="sm" v-model="d_rowModal.label" required)
				div(class="form-group")
					label Data Type
					b-form-select(size="sm" :options="d_dataTypes"  plain value='text' v-model="d_rowModal.type" @change="m_dataTypeChange" required)
				div(class="form-group")
					label(class="required-label") Used on
					b-form-select(size="sm" :options="d_usedOn" plain v-model="d_rowModal.context" required)
				div(class="form-group" style="margin-bottom:0px;")
					label List of values
					//-b-form-textarea(size="sm" v-model="d_rowModal.listOfValues" rows=3 placeholder="Enter list of valid values separated by comma.")
					b-form-tags(size="md" v-model="d_rowModal.listOfValues" tag-pills tag-variant="light" separator="," placeholder="Enter new value")
				div(class="form-group" style="width:100%;margin-left:200px;margin-top:0px;")
					label Multiple Selection
					b-form-checkbox(size="sm" v-model="d_rowModal.multiSelect" :disabled="c_disabledMultiSelect")
				div(class="form-group")
					label Disabled
					b-form-checkbox(v-model="d_rowModal.disabled")
			
			//- Decision & Debrief Questions
			div(v-else-if="(/^(decs|debr)$/).test(c_grpKey)" class="mb-3")
				div(class="form-group" v-if="d_rowModal.id")
					label Id
					span {{d_rowModal.id}}
				div(class="form-group")
					label(class="required-label") Question
					b-form-textarea(size="sm" v-model="d_rowModal.question" no-resize rows=3 required)
				div(class="form-group")
					label Description
					b-form-textarea(size="sm" v-model="d_rowModal.description" no-resize  rows=5) 
				div(class="form-group" v-if="c_grpKey=='decs'")
					label Default Weight
					b-form-select(size="sm" :options="d_refData.decisionWeights" plain v-model="d_rowModal.defaultWeight")
				div(class="form-group")
					label Disabled
					b-form-checkbox(v-model="d_rowModal.disabled")
			
			//- Sales Goals Notes Categories
			div(v-else-if="c_grpKey == 'sg'" class="mb-3")
				div(class="form-group" v-if="d_rowModal.id")
					label Id
					span {{d_rowModal.id}}
				div(class="form-group")
					label Note Category
					b-form-input(size="sm" v-model="d_rowModal.noteCategory")
				div(class="form-group")
					label Description
					b-form-textarea(size="sm" v-model="d_rowModal.description" no-resize rows=3) 
				div(class="form-group")
					label Disabled
					b-form-checkbox(v-model="d_rowModal.disabled")
			//- Construction Scopes
			div(v-else-if="c_grpKey == 'cs'" class="mb-3")
				div(class="form-group" v-if="d_rowModal.id")
					label Id
					span {{d_rowModal.id}}
				div(class="form-group")
					label(class="required-label") Construction Division
					b-form-input(size="sm" v-model="d_rowModal.constructionDivision" required)
				div(class="form-group")
					label(class="required-label") Construction Scope
					b-form-input(size="sm" v-model="d_rowModal.constructionScope" required)
				div(class="form-group")
					label Description
					b-form-textarea(size="sm" v-model="d_rowModal.description" no-resize rows=3) 
				div(class="form-group")
					label Disabled
					b-form-checkbox(v-model="d_rowModal.disabled")
			//- Vendor Status
			div(v-else-if="c_grpKey == 'vs'" class="mb-3")
				div(class="form-group" v-if="d_rowModal.id")
					label Id
					span {{d_rowModal.id}}
				div(class="form-group")
					label(class="required-label") Vendor Status
					b-form-input(size="sm" v-model="d_rowModal.vendorStatus" required)
				div(class="form-group")
					label Description
					b-form-textarea(size="sm" v-model="d_rowModal.description" no-resize rows=3) 
				div(class="form-group")
					label Disabled
					b-form-checkbox(v-model="d_rowModal.disabled") 
					
			div(v-else-if="c_grpKey === 'intf'" class="mb-3")

				// ID field (only when editing)
				div.form-group(v-if="d_rowModal.id")
					label Id
					span {{ d_rowModal.id }}

				// Interface Name selector
				div.form-group
					label Interface Name
					b-form-select(
					size="sm"
					:options="c_interfaces"
					plain
					v-model="d_rowModal.interfaceName"
					)
 										
				div.form-group
					label Description
					b-form-textarea(
					size="sm"
					v-model="d_rowModal.description"
					no-resize
					rows="3"
					)

				div.form-group(v-if="p_settingData.context === 'inbound'")
					label Data To Send
					b-form-select(
					size="sm"
					:options="d_outboundData"
					plain
					v-model="d_rowModal.outboundData"
					)


			div(class="note" v-if="(/^(ddo|decs|debr|sg)$/).test(c_grpKey) && d_rowModal.id")
				span Note: Changes made to this "{{c_label}}" value will be reflected on all exising records (if any) referencing it. 
				span If the change is material, significantly altering its definition, it is recommended that a new "{{c_label}}" is added instead.  
			template(slot="modal-header")
				div
					span(class="mr-2") {{(d_rowModal.id ? 'Edit ' : 'Add ') + c_label}}

</template>

<script>
import util, {kbdpAlert} from "@/utils/util.js";
import {refData} from "@/utils/ref-data.js";
import {settings as api} from "@/utils/api.js";
import KTMyPagesSettings from '@/components/Ctrl/KT-MyPagesSettings.vue';
export default {
	name: "kt-settings-tbl",
	components: {"kt-myPages-settings":KTMyPagesSettings},
	created() {
		fn_prepCols(this);
		//console.log(this.p_settingProps);
			//let skey = this.p_settingProps.key;
			switch (this.c_grpKey) {
				case 'usr':{this.d_dataKeyName='userName';break;}
				case 'ddo':{this.d_dataKeyName=this.p_settingProps.key + 'Name';break;}
				case 'decs':{this.d_dataKeyName='question';break;}
				case 'debr':{this.d_dataKeyName='question';break;}
				case 'sg':{this.d_dataKeyName='noteCategory';break;}
				case 'cf':{this.d_dataKeyName='label';break;}
				case 'cs':{this.d_dataKeyName='constructionDivision';break;}
				case 'vs':{this.d_dataKeyName='vendorStatus';break;}
			}
	},
	mounted() {

// Record Dragging
	var currRow = null,
	dragElem = null,
	mouseDownX = 0,
	mouseDownY = 0,         
	mouseX = 0,
	mouseY = 0,      
	mouseDrag = false;
	const table = document.getElementById('draggableTable');
	const tbody = table.querySelector('tbody');
	let _this=this;
	
			
	function getTargetRow(target) {
		let elemName = target.tagName.toLowerCase();

		if(elemName == 'tr') return target;
		if(elemName == 'td') return target.closest('tr');     
	}
	
	function swapRow(row, index) {
		let currIndex = Array.from(tbody.children).indexOf(currRow),
		row1 = currIndex > index ? currRow : row,
		row2 = currIndex > index ? row : currRow;
         
		tbody.insertBefore(row1, row2);
		
	}
  
  
  function getStyle(target, styleName) {
		let compStyle = getComputedStyle(target),
		style = compStyle[styleName];
		return style ? style : null;
	}  
  
	function isIntersecting(min0, max0, min1, max1) {
		return 	Math.max(min0, max0) >= Math.min(min1, max1) &&
				Math.min(min0, max0) <= Math.max(min1, max1);
	} 

	function moveRow(x, y) {
		dragElem.style.transform = "translate3d(" + x + "px, " + y + "px, 0)";
    
		let	dPos = dragElem.getBoundingClientRect(),
		currStartY = dPos.y, currEndY = currStartY + dPos.height,
        //rows = getRows();
		rows=table.querySelectorAll('tbody tr');

    for(var i = 0; i < rows.length; i++) {
		let rowElem = rows[i],
			rowSize = rowElem.getBoundingClientRect(),
			rowStartY = rowSize.y, rowEndY = rowStartY + rowSize.height;

		if(currRow !== rowElem && isIntersecting(currStartY, currEndY, rowStartY, rowEndY)) {
		if(Math.abs(currStartY - rowStartY) < rowSize.height / 2) swapRow(rowElem, i);
		}
	}    
}
  
  function addDraggableRow(target) {    
		dragElem = target.cloneNode(true);
		dragElem.classList.add('draggable-table__drag');
		dragElem.style.height = getStyle(target, 'height');
		dragElem.style.background = getStyle(target, 'backgroundColor');     
		for(var i = 0; i < target.children.length; i++) {
        let oldTD = target.children[i],
            newTD = dragElem.children[i];
        newTD.style.width = getStyle(oldTD, 'width');
        newTD.style.height = getStyle(oldTD, 'height');
        newTD.style.padding = getStyle(oldTD, 'padding');
        newTD.style.margin = getStyle(oldTD, 'margin');
      }      
      
		table.appendChild(dragElem);

    
		let tPos = target.getBoundingClientRect(),
		dPos = dragElem.getBoundingClientRect();
		dragElem.style.bottom = ((dPos.y - tPos.y) - tPos.height) + "px";
		dragElem.style.left = "-1px";    
    
		document.dispatchEvent(new MouseEvent('mousemove',
        { view: window, cancelable: true, bubbles: true }
		));

		
  }  	
  
			
			
			document.addEventListener('mousedown', (event) => {
			if(event.button != 0) return true;
      
				let target = getTargetRow(event.target);
				if(target) {
					currRow = target;
					addDraggableRow(target);
					currRow.classList.add('is-dragging');
					let coords = {x: event.clientX,y: event.clientY};
					mouseDownX = coords.x;
					mouseDownY = coords.y;      
					mouseDrag = true;   
				}
			});
			
			document.addEventListener('mousemove', (event) => {
				if(!mouseDrag) return;
      
				let coords = {x: event.clientX,y: event.clientY};
				mouseX = coords.x - mouseDownX;
				mouseY = coords.y - mouseDownY;  
      
				moveRow(mouseX, mouseY);
			});
			
    
			document.addEventListener('mouseup', (event) => {
			if(!mouseDrag) return;

				
				currRow.classList.remove('is-dragging');
				table.removeChild(dragElem);
      
				dragElem = null;
				mouseDrag = false;			
				//var ids = [];
				var settingsOrder=[];
				var table2 = document.getElementsByTagName('table')[0];
				var rows = table2.rows;
				console.log('rows');
				console.log(rows);
				for (var i = 0; i < rows.length; i++) {
				var rowText = rows[i];
				var tdNode1 = rowText.childNodes[1];
				//ids.push(rowText);
				settingsOrder.push($(tdNode1).text());
				}
				_this.d_settingsOrder=settingsOrder;
				_this.m_saveSettingsOrder();

			}); 	
	
	},
	data() {
		return {
			d_util: util,
			d_refData: refData,
			d_cols: [],
			d_data: [],
			d_rowModal: {},
			d_editIx: null,
			d_savedIx: null,
			d_dataTypes:[{value:'text',text:'Text'},
						{value:'number',text:'Number'},
						{value:'money',text:'Money'},
						{value:'date',text:'Date'},
						{value:'email',text:'Email'},
						{value:'tel',text:'Telephone'},
						{value:'checkbox',text:'Checkbox'},
						{value:'url',text:'Web Link'},
						{value:'time',text:'Time'},
						{value:'oppr',text:'Opportunity'},
						{value:'proj',text:'Project'},
						{value:'acct',text:'Account'},
						{value:'extr',text:'Contact'},
						{value:'cmpt',text:'Competitor'},
						{value:'team',text:'Team Member'},
						],
			d_usedOn:[{value:'oppr',text:'Opportunities'},
					{value:'proj',text:'Projects'},
					{value:'acct',text:'Accounts'},
					{value:'extr',text:'Contacts'},
					{value:'cmpt',text:'Competitors'},
					{value:'team',text:'Team Members'}],
			d_saved:false,
			d_context:"oppr",
			d_settingsOrder:null,
			d_dataKeyName:null,
			d_interfaces:[{interfaceName:"Quickbooks Payment", description:"Get actual payments from Quickbooks",type:"inbound"},
			              {interfaceName:"Procore", description:"Send Data to Procore",type:"outbound"},
						  ],
			d_outboundData:[{value:'oppr',text:'Opportunities'},
					        {value:'proj',text:'Projects'},
					        {value:'acct',text:'Accounts'},
					        {value:'extr',text:'Contacts'},
		                    ],
		};
	},
	props: {
		p_settingProps: Object,
		p_settingData: [Array, Object],
		p_refData: [Array, Object],
	},
	computed: {
		c_data(){return this.p_settingProps.context=='customField'?this.d_data.filter(d=>d.context==this.d_context):this.d_data;},
		c_appUserId(){return this.d_rowModal.appUserId;},
		c_saved(){return this.d_saved;},
		c_grpKey() {
			return this.p_settingProps.grpKey;
		},
		c_idKey() {
			return this.c_grpKey == 'usr' ? 'appUserId' : this.p_settingProps.context + 'Id';
		},
		c_label() {
			let sp = this.p_settingProps;
			return !sp ? null : sp.label || util.fn_humanizeLabel(sp.key);
		},

		c_userOpt() {
			let usrs = (this.p_refData || {}).appUsers;
			if (!usrs) return [];

			let dsbl = (this.d_data || []).map(x => x.appUserId);
			return usrs.map(x => ({
				'value': x.appUserId,
				'text': `${x.teamMemberName} (${x.userName})`,
				'disabled': dsbl.indexOf(x.appUserId) > -1,
			}));

		},
		c_permsOpt() {
			let perms = (this.p_settingProps || {}).propOpt;
			if (!perms) return [];
			return perms.map(x => ({
				'value': x,
				'text': util.fn_humanizeLabel(x)
			}));
		},
		c_disabledMultiSelect(){return !(this.d_rowModal.listOfValues||[]).length;},		
		c_dataKeyName(){
		var dataKeyName;
		switch (this.c_grpKey) {
				case 'usr':{dataKeyName='appUserId';break;}
				case 'ddo':{dataKeyName=this.p_settingProps.key + 'Name';break;}
				case 'decs':{dataKeyName='question';break;}
				case 'debr':{dataKeyName='question';break;}
				case 'sg':{dataKeyName='noteCategory';break;}
				case 'cf':{dataKeyName='label';break;}
				case 'cs':{dataKeyName='constructionDivision';break;}
				case 'vs':{dataKeyName='vendorStatus';break;}
			}
		return dataKeyName;
		},
		c_rowKeyName(){
		var rowKeyName;
		switch (this.c_grpKey) {
				case 'usr':{rowKeyName='appUserId';break;}
				case 'ddo':{rowKeyName='name';break;}
				case 'decs':{rowKeyName='question';break;}
				case 'debr':{rowKeyName='question';break;}
				case 'sg':{rowKeyName='noteCategory';break;}
				case 'cf':{rowKeyName='label';break;}
				case 'cs':{rowKeyName='constructionDivision';break;}
				case 'vs':{rowKeyName='vendorStatus';break;}
			}
		return rowKeyName;
		},
        c_interfaces() {
                  const { d_interfaces = [], p_settingProps } = this;
                  const context = p_settingProps?.context;

                  if (!context) return [];

                  return d_interfaces.filter(i => i?.type === context)
                        .map(i => i?.interfaceName)
                        .filter(Boolean);
            },

      						
	},
	methods: {
		m_dataTypeChange(){
							switch(this.d_rowModal.dataType){
								case 'oppr': {this.d_rowModal.listOfValues=["Opportunities"];break;}
								case 'proj': {this.d_rowModal.listOfValues=["Projects"];break;}
								case 'acct': {this.d_rowModal.listOfValues=["Accounts"];break;}
								case 'extr': {this.d_rowModal.listOfValues=["Contacts"];break;}
								case 'cmpt': {this.d_rowModal.listOfValues=["Competitors"];break;}
								case 'team': {this.d_rowModal.listOfValues=["Team Members"];break;}
							}
						},
		m_tdFmt(row, col) {
			switch (col.key) {
				case 'userName': return fn_getUserRef(this, row.appUserId).userName;
				case 'teamMemberName': return fn_getUserRef(this, row.appUserId).teamMemberName;
				case 'context': { var contextObj=this.d_usedOn.filter(u=>u.value==row[col.key])[0];
								return contextObj?contextObj.text:null;
								}
				case 'type': { var dataTypeObj=this.d_dataTypes.filter(u=>u.value==row[col.key])[0];
							return dataTypeObj?dataTypeObj.text:null;
							}
				case 'listOfValues': return row[col.key]?row[col.key].toString():null;
	
			}
			return row[col.key];
		},
		m_rowClassNm(ixr) {
			if (ixr == this.d_editIx) return 'kt-in-edit';
			if (ixr == this.d_savedIx) return 'kt-saved';
			return null;
		},
		m_editSetting(row, ixr) {
			switch (this.c_grpKey) {
				case 'usr':
					{
						this.d_rowModal = {
							id: -1,
							appUserId: row['appUserId'],
							permissions: row['permissions']
						};
						break;
					}
				case 'ddo':
				
					{
						let skey = this.p_settingProps.key;
						this.d_rowModal = {
							id: row[this.c_idKey],
							name: row[skey + 'Name'],
							desc: row[skey + 'Description'],
							disabled: row['disabled'],
						};
						break;
					}
				case 'decs':
					{
						this.d_rowModal = {
							id: row[this.c_idKey],
							question: row['question'],
							description: row['description'],
							defaultWeight: row['defaultWeight'],
							disabled: row['disabled'],
						};
						break;
					}
				case 'debr':
					{
						this.d_rowModal = {
							id: row[this.c_idKey],
							question: row['question'],
							description: row['description'],
							disabled: row['disabled'],
						};
						break;
					}
				case 'sg':
					{
						this.d_rowModal = {
							id: row[this.c_idKey],
							noteCategory: row['noteCategory'],
							description: row['description'],
							disabled: row['disabled'],
						};
						break;
					}
				case 'cf':
					{
						this.d_rowModal = {
							id: row[this.c_idKey],
							label: row['label'],
							type: row['type'],
							context: row['context'],
							description: row['description'],
							listOfValues:row['listOfValues'],
							disabled: row['disabled'],
							multiSelect: row['multiSelect'],
						};
						break;
					}
				case 'cs':
					{
						this.d_rowModal = {
							id: row[this.c_idKey],
							constructionDivision: row['constructionDivision'],
							constructionScope: row['constructionScope'],
							description: row['description'],
							disabled: row['disabled']
						};
						break;
					}
				case 'vs':
					{
						this.d_rowModal = {
							id: row[this.c_idKey],
							vendorStatus: row['vendorStatus'],
							description: row['description'],
							disabled: row['disabled']
						};
						break;
					}
				case 'intf':
					{
						this.d_rowModal = {
							id: row[this.c_idKey],
							interfaceName: row['interfaceName'],
							description: row['description'],
							disabled: row['disabled']
						};
						break;
					}
			}
			this.d_editIx = ixr;
			this.$bvModal.show('bm-kt-settings-tbl-item');
		},
		m_deleteSetting(row, ixr) {
			let content = {
				titleText: 'Confirm Delete',
				message1: `Are you sure you want to delete the ${this.c_label}?`
			};
			let cm = util.fn_getModal_confirm(this, content);

			let _this = this;
			_this.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then(resp => {
				if (!resp) return;
				
				let idKey = _this.c_idKey;
				let context = _this.p_settingProps.context;
				let contextId = row[idKey];

				kbdpAlert.showDeleting(_this.c_label);
				api.fn_delData(context, contextId).then((resp) => {

					if (resp.error || !resp.status) {
						let msg = `Unable to delete ${_this.c_label}. ` + (resp.error || '');
						kbdpAlert.showErr(msg);
						return;
					}
					let ix = _this.d_data.map(x => x[idKey]).indexOf(contextId);
					_this.d_data.splice(ix, 1);

					kbdpAlert.showOk(this.c_label + ' was deleted successfully.');
				});
			});
		},
		m_addSetting() {
			this.d_rowModal = {};
			if(this.d_context) this.d_rowModal['context']=this.d_context;
			this.$bvModal.show('bm-kt-settings-tbl-item');
		},
		m_saveSetting(bvModal) {
			let sp = this.p_settingProps;
			this.d_rowModal['context']=this.d_context;
			let settingData = this.d_rowModal;
		if(this.c_grpKey !=='usr'&&fn_chkDups(this,settingData)) {
			kbdpAlert.clear();
			let msg =  `Unable to save this ${this.c_label} as duplicate exists.`;
			kbdpAlert.showErr(msg);	
			bvModal.preventDefault();
		}
		else{
			this.d_saved=true;
			
			if(this.c_grpKey=='cf') 
				settingData["name"]=util.fn_humanizeLabel(settingData.label).split(' ').join('');
				
			let _this = this;
			

			if (Object.keys(settingData).length == 0) return;
			
			kbdpAlert.showSaving(_this.c_label);
			api.fn_saveData(sp.context, sp.category, settingData).then((resp) => {
				if (resp.error || !resp.settingData) {
					let msg = `Unable to save ${_this.c_label}. ` + (resp.error || '');
					kbdpAlert.showErr(msg);
					return;
				}

				_this.d_editIx = null;
				let saved = resp.settingData[0];


				
				if (_this.d_rowModal.id) { //Existing
					let idKey = _this.c_idKey;
					let ix = _this.d_data.map(x => x[idKey]).indexOf(saved[idKey]);
					_this.d_data.splice(ix, 1, saved);
					_this.d_savedIx = ix;
				}
				else {//New
					_this.d_data.push(saved);
					_this.d_savedIx = _this.d_data.length - 1;
				}
				
				kbdpAlert.showOk(this.c_label + ' was saved successfully.');
				setTimeout(() => {_this.d_savedIx = null;}, 1500);
				_this.d_rowModal = {};
			});
		}
	},
	m_saveSettingsOrder(){

			let _this=this;
			var settingsOrder=this.d_settingsOrder;
			var settingsDataOrder=this.d_data.map(d=>{
						var sequenceNo=settingsOrder.indexOf(d[this.c_dataKeyName])+1;
						d['sequenceNo']=sequenceNo;
						return {id: d[this.c_idKey],sequenceNo:sequenceNo};
					})
			let sp = this.p_settingProps;

			api.fn_saveDataOrder(sp.context, sp.category, settingsDataOrder).then((resp) => {
				if (resp.error) {
					let msg = `Unable to save reorder of ${_this.c_label}. ` + (resp.error || '');
					kbdpAlert.showErr(msg);
					return;
				}
			})
		},
	},
	watch: {
		p_settingData(val) {
			if (!Array.isArray(val)) {
				this.d_data = [];
			}
			else {
				this.d_data = val;
			}
		},
		'p_settingProps.key'() {
			fn_prepCols(this);
			kbdpAlert.clear();
		}
	}
};

function fn_prepCols(vc) {

	
	let sp = vc.p_settingProps;

	if (sp.grpKey == 'ddo') {
		sp.cols.forEach(c => {
			if (/^(Id|Name|Description|Value)$/.test(c.title)) c.key = sp.key + c.title;
		});
	}
	vc.d_cols = sp.cols;
}

function fn_getUserRef(vc, auId) {
	let usrs = (vc.p_refData || {}).appUsers;
	if (!usrs) return {};
	else return usrs.filter(x => x.appUserId == auId)[0] || {};
}
function fn_chkDups(vc,rowData) {
	var rowDataId=rowData.id?rowData.id:0;
	var duplicateSettings=vc.d_data.filter(d=>d[vc.c_dataKeyName]==rowData[vc.c_rowKeyName] &&d[vc.c_idKey]!==rowDataId);
	return duplicateSettings.length;
	}

</script>

<style lang="less">
.kt-settings-tbl {
    .btn-save,
	.btn-cancel,
	.btn-add {
		padding: 0.1em 0.5em 0.1em 0.5em;
		font-size: 0.9em;
		margin-right: 0.5em;
	}
	table {
		margin-bottom: 50px;
		thead {
			background-color: #f8f9fa;
			th {
				border-bottom: solid 0.2em #495057;
				vertical-align: middle;
			}
			th.th-edit {
				width1: 50px;
			}
			th.th-chkBox {
				width1: 75px;
			}
		}
		tbody {
			tr td:first-child {
				.dropdown-toggle {
					font-size: 1em;
					color: #6c757d;
				}
				.dropdown-item {
					border-bottom: solid 0.1em #ced4da;
					padding: 0.2em 0.5em;
				}
			}
			tr.kt-in-edit {
				background-color: #e9ecef;
			}
			tr.kt-saved {
				background-color: #e0f0ff;
				td span.btn {
					display: none;
				}
			}
			tr td.td-crup {
				font-size: 0.9em;
				min-width: 80px;
			}
			// tr td.td-usr,
			// tr td.td-dtm {
			// 	font-size: 0.9em;
			// 	font-stretch: condensed;
			// 	max-width: 115px;
			// }
			tr td input[type="checkbox"] {
				pointer-events: none;
				margin-left: 1.5em;
			}
			tr td p {
				margin-bottom: 0;
			}
		}
	}
}
#bm-kt-settings-tbl-item {
	.form-group {
		display: flex;
		> label {
			min-width: 110px;
			width: 25%;
			font-size: 0.9em;
		}
		> input,
		> textarea,
		> div {
			width: 75%;

			> label {
				font-size: 0.8em;
				color: #6c757d;
				padding-top: 0.15em;
			}
		}

		> select {
			width: 200px;
			height: 31px;
		}
	}

	.note {
		font-size: 0.8em;
		line-height: 1.2em;
		color: #dc3545;
	}
}
table1 thead {
  padding: 3px;
  position: sticky;
  top: 100px;
  z-index: 1;
}
.modalFooter{margin-top:10px;}
.btn-reorder-row{
	opacity:0.5;
	cursor: move;
	padding: 0;
	opacity: 0.5;
	font-size: 0.8em;
	background-color: #e9ecef;
}
.draggable-table {
position: absolute;
1border-collapse: collapse;
background: white;    
.draggable-table__drag { 
position: absolute;
z-index: 10;
cursor: move;
opacity: 1;
 }  
 tbody {
    tr {cursor: move }
    tr.is-dragging {
        background1: #007bff;      //#f1c40f;
        td {color1: #ffe683; }
    }    
  }
}
.btn1-save,
.btn1-cancel {
		min-width: 50px;
		padding: 0em 0.4em;
		margin-right: 0.5em;
	}
sup {
    vertical-align: super;
    font-size: smaller;
}
.btn-reorder
	{
	opacity: 0.5;
	font-size: 0.8em;
	background-color: #e9ecef;
	cursor: move;
	box-shadow: unset;
	&:hover {
			opacity: unset;
			}
	}
</style>